import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import GetPageHtml from 'src/components/GetPageHtml/GetPageHtml.obfuscate';
import ContextSubtitleWithoutVacancy from 'src/components/Search/Resume/ContextVacancy/SubtitleWithoutVacancy';
import HeaderChips from 'src/components/Search/Resume/Filters/Geo/HeaderChips';
import { useGeoFiltersRedesignExp } from 'src/components/Search/Resume/Filters/Geo/hooks/useGeoFiltersRedesignExp';

import Banners from 'src/components/Search/Resume/Header/Banners';
import QueryFixer from 'src/components/Search/Resume/Header/QueryFixer';
import QuerySuggest from 'src/components/Search/Resume/Header/QuerySuggest';
import Title from 'src/components/Search/Resume/Header/Title';
import CatalogTitle from 'src/components/Search/Resume/Header/Title/Catalog';

const ResumeSearchHeader: FC<{ isSeoCatalog?: boolean }> = ({ isSeoCatalog }) => {
    const isGeoFiltersRedesignExp = useGeoFiltersRedesignExp();

    return (
        <>
            {isSeoCatalog ? (
                <CatalogTitle />
            ) : (
                <>
                    <Title />
                    <QueryFixer />
                    <QuerySuggest />
                </>
            )}
            <ContextSubtitleWithoutVacancy />
            {isGeoFiltersRedesignExp && <HeaderChips />}
            <VSpacing default={24} />
            <Banners />
            {/* write html page to logs */}
            <GetPageHtml />
        </>
    );
};

export default ResumeSearchHeader;
